import { render, staticRenderFns } from "./Necessity.vue?vue&type=template&id=1d7af485&scoped=true&"
import script from "./Necessity.vue?vue&type=script&lang=js&"
export * from "./Necessity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7af485",
  null
  
)

export default component.exports